module.exports = __webpack_public_path__ + "static/monthly-star.48a27e28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHome/images/monthly-star.jpg
// module id = 179
// module chunks = 168707334958949